import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconKeyhole: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconKeyhole"><Path fillRule="evenodd" clipRule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM15.25 10C15.25 11.2539 14.5399 12.3419 13.5 12.8839V15.75C13.5 16.5784 12.8284 17.25 12 17.25C11.1716 17.25 10.5 16.5784 10.5 15.75V12.8839C9.46005 12.3419 8.75 11.2539 8.75 10C8.75 8.20507 10.2051 6.75 12 6.75C13.7949 6.75 15.25 8.20507 15.25 10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconKeyhole;
